import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess404052ZpModulStatus: 'idle',
    startProcess404052ZpModulError: undefined as any,
    loadUserParamsProcess404052ZpModulStatus: 'idle',
    loadUserParamsProcess404052ZpModulError: undefined as any,

    process404052ZpModulList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess404052ZpModul = createAsyncThunk('process404052ZpModulSlice/startProcess404052ZpModul', async ({ process404052ZpModul }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess404052ZpModul/`,
        prepareData(process404052ZpModul),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess404052ZpModulStatus } = getState().process404052ZpModulSlice
        return startProcess404052ZpModulStatus !== 'pending'
    }
})

export const loadUserParamsProcess404052ZpModul = createAsyncThunk('process404052ZpModulSlice/loadUserParamsProcess404052ZpModul', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess404052ZpModul/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess404052ZpModulStatus } = getState().process404052ZpModulSlice
        return loadUserParamsProcess404052ZpModulStatus !== 'pending'
    }
})

const Process404052ZpModulSlice = createSlice({
    name: 'process404052ZpModulSlice',
    initialState,
    reducers: {
        resetstartProcess404052ZpModul: (state) => {
            state.job = undefined
            state.startProcess404052ZpModulError = undefined
        },
        resetstartProcess404052ZpModulError: (state) => {
            state.startProcess404052ZpModulError = undefined
        },
        resetloadUserParamsProcess404052ZpModul: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess404052ZpModulError = undefined
        },
        resetloadUserParamsProcess404052ZpModulError: (state) => {
            state.loadUserParamsProcess404052ZpModulError = undefined
        },
        removeFromProcess404052ZpModulListById: (state, action) => {
            state.process404052ZpModulList = state.process404052ZpModulList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess404052ZpModulListByIds: (state, action) => {
            state.process404052ZpModulList = state.process404052ZpModulList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process404052ZpModulList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess404052ZpModulStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process404052ZpModulList = []
            state.startProcess404052ZpModulStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess404052ZpModul.pending, (state) => {
            state.startProcess404052ZpModulStatus = 'pending'
            state.startProcess404052ZpModulError = undefined
        })
        builder.addCase(startProcess404052ZpModul.fulfilled, (state, action) => {
            state.startProcess404052ZpModulStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess404052ZpModul.rejected, (state, action) => {
            state.startProcess404052ZpModulStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess404052ZpModulError = action.error.message
            } else {
                state.startProcess404052ZpModulError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess404052ZpModul.pending, (state) => {
            state.loadUserParamsProcess404052ZpModulStatus = 'pending'
            state.loadUserParamsProcess404052ZpModulError = undefined
        })
        builder.addCase(loadUserParamsProcess404052ZpModul.fulfilled, (state, action) => {
            state.loadUserParamsProcess404052ZpModulStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess404052ZpModul.rejected, (state, action) => {
            state.loadUserParamsProcess404052ZpModulStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess404052ZpModulError = action.error.message
            } else {
                state.loadUserParamsProcess404052ZpModulError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess404052ZpModul,
    resetstartProcess404052ZpModulError,
    resetloadUserParamsProcess404052ZpModul,
    resetloadUserParamsProcess404052ZpModulError,
    removeFromProcess404052ZpModulListById,
    removeFromProcess404052ZpModulListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process404052ZpModulSlice.actions
export default Process404052ZpModulSlice.reducer
